import React from "react";
import "./proyectos.css";
import web1 from "../Imgs/web1.jpg";
import web2 from "../Imgs/web2.jpg";
import web3 from "../Imgs/web3.jpg";
import web4 from "../Imgs/web4.jpg";
import web5 from "../Imgs/web5.jpg";
import web6 from "../Imgs/web6.jpg";
import web7 from "../Imgs/web7.jpg";
import web8 from "../Imgs/web8.jpg";
import web9 from "../Imgs/web9.jpg";
import SEO from "../Componentes/seo";

const Proyectos = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Proyectos web | Juan Camilo Muñoz",
    url: "https://portafoliojcmr.netlify.app/proyectos",
    description:
      "Muestra de proyectos web desarrollados por Juan Camilo Muñoz para negocios, portafolios, tiendas online y soluciones digitales."
  };

  const sitios = [
    {
      img: web5,
      alt: "Ofiya",
      titulo: "Ofiya",
      descripcion:
        "Plataforma de aprendizaje online con una experiencia clara, práctica y enfocada en facilitar el acceso al contenido.",
      enlace: "https://ofiya.com.co/",
    },
    {
      img: web6,
      alt: "Duck Fantasy",
      titulo: "Duck Fantasy",
      descripcion:
        "Juego RPG online con una propuesta entretenida, dinámica y pensada para exploraciones rápidas dentro de la web.",
      enlace: "https://duckfantasy.netlify.app/",
    },
    {
      img: web7,
      alt: "ParceShop",
      titulo: "ParceShop",
      descripcion:
        "Tienda online con enfoque comercial, navegación sencilla y una presentación pensada para impulsar ventas.",
      enlace: "https://parceshop.netlify.app/",
    },
    {
      img: web8,
      alt: "Alrock Burger",
      titulo: "Alrock Burger",
      descripcion:
        "Sitio web para restaurante con una propuesta visual atractiva y orientación directa a la experiencia del cliente.",
      enlace: "https://alrockburger.netlify.app/",
    },
    {
      img: web9,
      alt: "Tecnolosys",
      titulo: "Tecnolosys",
      descripcion:
        "Tienda online de tecnología con un estilo moderno, ordenado y preparado para destacar su catálogo de productos.",
      enlace: "https://www.tecnolosys.com/",
    },
    {
      img: web3,
      alt: "JCMR Fitness",
      titulo: "JCMR Fitness",
      descripcion:
        "Tienda online de suplementos y ropa deportiva, con diseño responsive, ágil y listo para vender.",
      enlace: "https://jcmrfitness.netlify.app/",
    },
    {
      img: web1,
      alt: "TCELMEC LTDA",
      titulo: "TCELMEC LTDA",
      descripcion:
        "Sitio institucional para empresa metalmecánica, enfocado en servicios técnicos y presencia profesional.",
      enlace: "https://tcelmec.netlify.app/",
    },
    {
      img: web2,
      alt: "DataProControl",
      titulo: "DataProControl",
      descripcion:
        "ERP web orientado a optimizar la gestión empresarial: compras, almacén, contabilidad, nómina y más.",
      enlace: "https://camilomr57.wixsite.com/datawise",
    },
    {
      img: web4,
      alt: "JCMR WEB",
      titulo: "JCMR WEB",
      descripcion:
        "Portafolio de servicios de ingeniería mecánica con una presentación clara y directa.",
      enlace: "https://jcmr.netlify.app/",
    },
  ];

  return (
    <div className="app1Certificados">
      <SEO
        title="Proyectos web de Juan Camilo Muñoz"
        description="Explora los proyectos web creados por Juan Camilo Muñoz: tiendas online, portafolios, sitios institucionales y soluciones digitales para clientes."
        path="/proyectos"
        keywords={[
          "proyectos web",
          "portafolio de proyectos",
          "React",
          "sitios web",
          "tienda online",
          "Juan Camilo Muñoz"
        ]}
        structuredData={structuredData}
      />
      <h2 className="app1tex1c">Conoce los resultados de mis últimos proyectos</h2>
      <div className="proyectos-grid">
        {sitios.map((sitio) => (
          <div className="proyecto-card" key={sitio.titulo}>
            <img src={sitio.img} alt={sitio.alt} />
            <div className="proyecto-content">
              <h3>{sitio.titulo}</h3>
              <p>{sitio.descripcion}</p>
              <a href={sitio.enlace} target="_blank" rel="noopener noreferrer">
                Ver sitio
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Proyectos;
